<div class="row p-2">
    <div class="d-block">
      <div *ngIf="recordData.length > paginatorOptions.limit" class="form-group float-start col-lg-4 col-sm-12 d-flex">
        <label><span style="color: red;"> * </span>Number of records page</label>
        <select class="form-control form-control-sm small-dd" [(ngModel)]="limit" (change)="limitChanged(limit)">
            <option *ngFor="let dropValue of dropdownOptions" [ngValue]="dropValue.value">
                {{dropValue.display}}
            </option>
        </select>
      </div>
      <div class="float-end">
          <pagination-controls (pageChange)="pageChanged($event)" (pageBoundsCorrection)="pageChanged($event)"
              [maxSize]="maxSize" [directionLinks]="directionLinks" [responsive]="true"
              [previousLabel]="previousLabel" [nextLabel]="nextLabel" screenReaderPaginationLabel="Pagination"
              screenReaderPageLabel="page" screenReaderCurrentLabel="You're on page">
          </pagination-controls>
      </div>
    </div>
  </div>